module.exports = __webpack_public_path__ + "static/media/2_Recover My Account.9fe705ad.jpg";